<script>
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import lowerBanner from './images/03-image-IRA-LP.jpg?quality=95';
</script>

<Section backgroundImage={lowerBanner} backgroundColor="blue">
	<h2
		class="
    w-full
    max-md:text-left
  "
	>
		Guaranteed For a Lifetime
	</h2>
	<p
		class="
    max-md:text-left
    md:text-balance
  "
	>
		Your Indow inserts are fully-backed by our <a
			href="/warranties/residential-lifetime-warranty">Lifetime Warranty</a
		>
		and

		<a href="/warranties/snug-fit-guarantee">Snug-Fit Guarantee.</a> We'll guide you
		through every step of the purchase process and even send you a state-of-the-art
		laser measuring kit to ensure your inserts fit right - no matter the shape or
		size.
	</p>
</Section>
